import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IControls, IDialog } from 'BI-Libraries/BI-Interfaces/dist/bi-interfaces';
import { DataTypes } from 'BI-Libraries/BI-Interfaces/dist/bi-interfaces';
import { ControlTypes } from 'BI-Libraries/BI-Interfaces/projects/bi-interfaces/src/lib/enums/ControlTypes';
import { HttpService } from 'src/app/shared/services/HttpClientServices/Http.service';
import { saveAs } from '@progress/kendo-file-saver';


@Component({
  selector: 'app-request-license-dialog',
  templateUrl: './request-license-dialog.component.html',
  styleUrl: './request-license-dialog.component.scss',
})
export class RequestLicenseDialogComponent implements  IDialog {

  public DialogDataSource: any;
  public generalControls: IControls[] = [];
  formGroup!: FormGroup;

  constructor(
    @Inject('datasource') public _datasource,
    public translate: TranslateService,
    public formBuilder: FormBuilder,
    public httpservice: HttpService,
  ) {
    this.DialogDataSource = this._datasource();
    this.CreateGeneralControls();
    this.formGroup = this.formBuilder.group({});
    this.createFormGroup(this.generalControls, this.formGroup)

  }

  ngOnInit() {
    this.httpservice.get('api/License/GetLicenseData').subscribe(res => {
      this.formGroup.controls['DBName'].setValue(res?.DBName)
      this.formGroup.controls['InstanceName'].setValue(res?.InstanceName)
      this.formGroup.controls['MachineKey'].setValue(res?.MachineKey)
      this.formGroup.controls['ServerType'].setValue(res?.ServerType)
    });

  }
  data: any;
  outputValue: any;
  OnOk() {
    this.httpservice.postXML('api/License/RequestFileData', {
      "ContactEmail": this.formGroup.controls['ContactEmail'].value ?? null,
      "CustomerName": this.formGroup.controls['CustomerName'].value ?? null,
      "Phone": this.formGroup.controls['Phone'].value ?? null,
      "ServerType": this.formGroup.controls['ServerType'].value ?? null
    }).subscribe(
      res => {
        console.log(res)
        const blob = new Blob([res], { type: 'application/xml' });
        saveAs(blob, 'License.xml')
      }
    );
  }

  OnCancel() {
  }

  createFormGroup(controls: IControls[], formGroup: FormGroup) {
    controls.forEach((control) => {
      formGroup.addControl(control.Name, this.formBuilder.control({ value: null, disabled: !control.IsEditable }));
    });
  }
  CreateGeneralControls() {
      this.generalControls = [
        {
          colNumber: 1,
          rowNumber: 1,
          DisplayName: "MachineKey",
          DomID: "MachineKey",
          Name: "MachineKey",
          DataType: DataTypes.Text,
          controlType: "text",
          Validators: null,
          IsEditable: false,
          IsFilterable: false,
          DefaultValue: null,
          viewCellStyle: "",
          IsVisible: true,
        },
        {
          colNumber: 2,
          rowNumber: 1,
          DisplayName: "SQLServerInstanceName",
          DomID: "InstanceName",
          Name: "InstanceName",
          DataType: DataTypes.Text,
          controlType: "text",
          Validators: null,
          IsEditable: false,
          IsFilterable: false,
          DefaultValue: null,
          viewCellStyle: "",
          IsVisible: true,
        },
        {
          colNumber: 1,
          rowNumber: 2,
          DisplayName: "SQLServerDBName",
          DomID: "DBName",
          Name: "DBName",
          DataType: DataTypes.Text,
          controlType: "text",
          Validators: null,
          IsEditable: false,
          IsFilterable: false,
          DefaultValue: null,
          viewCellStyle: "",
          IsVisible: true,
        },
        {
          colNumber: 2,
          rowNumber: 2,
          DisplayName: "ServerType",
          DomID: "ServerType",
          Name: "ServerType",
          DataType: DataTypes.Text,
          controlType: ControlTypes.Select,
          Validators: null,
          IsEditable: true,
          IsFilterable: false,
          DefaultValue: 1,
          viewCellStyle: "",
          IsVisible: true,
          dropDownTemplate: {
            value: 'code',
            text: 'text',
            list: [
              { text: this.translate.instant("Test"), code: 0 },
              { text: this.translate.instant("Production"), code: 1 },
            ]
          }
        },
        {
          colNumber: 1,
          rowNumber: 3,
          DisplayName: "CustomerName",
          DomID: "CustomerName",
          Name: "CustomerName",
          DataType: DataTypes.Text,
          controlType: "text",
          Validators: null,
          IsEditable: true,
          IsFilterable: false,
          DefaultValue: null,
          viewCellStyle: "",
          IsVisible: true,
        },
        {
          colNumber: 2,
          rowNumber: 3,
          DisplayName: "Phone",
          DomID: "Phone",
          Name: "Phone",
          DataType: DataTypes.Text,
          controlType: "text",
          Validators: null,
          IsEditable: true,
          IsFilterable: false,
          DefaultValue: null,
          viewCellStyle: "",
          IsVisible: true,
        },
        {
          colNumber: 1,
          rowNumber: 4,
          DisplayName: "Email",
          DomID: "ContactEmail",
          Name: "ContactEmail",
          DataType: DataTypes.Text,
          controlType: "text",
          Validators: null,
          IsEditable: true,
          IsFilterable: false,
          DefaultValue: null,
          viewCellStyle: "",
          IsVisible: true,
        },
      ];
    }
}
